module.exports = __webpack_public_path__ + "static/media/si.e5962056.svg";